export default function PushToEhrFailureIcon({ width = 32, height = 32, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <circle cx='16' cy='16' r='16' fill='#883E11' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16 23C19.866 23 23 19.866 23 16C23 12.134 19.866 9 16 9C12.134 9 9 12.134 9 16C9 19.866 12.134 23 16 23ZM16 12.125C16.4142 12.125 16.75 12.4608 16.75 12.875V16.125C16.75 16.5392 16.4142 16.875 16 16.875C15.5858 16.875 15.25 16.5392 15.25 16.125V12.875C15.25 12.4608 15.5858 12.125 16 12.125ZM17 18.875C17 19.4273 16.5523 19.875 16 19.875C15.4477 19.875 15 19.4273 15 18.875C15 18.3227 15.4477 17.875 16 17.875C16.5523 17.875 17 18.3227 17 18.875Z'
        fill='white'
      />
    </svg>
  );
}
